<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<div class="col-md-12 form-group-inline mb-4">
						<label class="col-form-label label-md col-md-3">Tanggal Penyimpanan</label>
						<div class="col-md-3">
							{{models.tglProses | formatDate}}
						</div>
					</div>

					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Sumber Sampah B3</label>
						<div class="col-md-9">
							<b-form-group v-if="models.fasilitasSumber" label="Kota">
								{{ models.fasilitasSumber.kota ? models.fasilitasSumber.kota.namaKota : ""  }}
							</b-form-group>
							<b-form-group v-if="models.fasilitasSumber" label="Kecamatan">
								{{ models.fasilitasSumber.kecamatan ? models.fasilitasSumber.kecamatan.namaKecamatan : "" }}
							</b-form-group>
							<b-form-group label="Jenis Fasilitas">
								<div class="col-sm-12 no-padding">
									{{ getJenisFasilitasById(models.jnsFasilitasSumber) }}
								</div>
							</b-form-group>
							<b-form-group label="Fasilitas B3">
								<template v-if="models.fasilitasSumber">
									{{  models.fasilitasSumber.namaFasilitas }}
								</template>
							</b-form-group>
							<b-form-group label="Alamat Fasilitas B3">
								{{ models.fasilitasSumber ? models.fasilitasSumber.alamatFasilitas : "" }}
							</b-form-group>
						</div>
					</div>
					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Jenis Sampah B3(Kg)</label>
						<div class="col-md-9">
							<b-form-group class="col-md-6" label="Sisa Produk Mengandung B3">
								{{ models.sisaProdukMengandungB3 }} Kg
							</b-form-group>
							<template>
								<p class="col-form-label fs-15px">Sampah Elektronik e-Waste</p>
								<b-row class="ml-1">
									<b-form-group class="col-md-6" label="Peralatan Pendingin Makanan & Penyejuk Udara">
										{{  models.sampahEwastePendingin }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Berukuran Besar">
										{{ models.sampahEwasteBesar }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Berukuran Kecil">
										{{ models.sampahEwasteKecil}} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Komunikasi, Teknologi Informasi dan Layar Monitor">
										{{ models.sampahEwasteKomunikasiTi }} Kg
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Pencahayaan">
										{{  models.sampahEwastePencahayaan }} Kg
									</b-form-group>
								</b-row>
							</template>

							<p class="col-form-label fs-15px">Sampah Kemasan B3</p>
							<b-row class="ml-1">
								<b-form-group class="col-md-6" label="Kemasan Kaleng">
									{{models.sampahKemasanKaleng}} Kg
								</b-form-group>
								<b-form-group class="col-md-6" label="Kemasan Plastik">
									{{ models.sampahKemasanPlastik }} Kg
								</b-form-group>
							</b-row>
							<p class="col-form-label fs-15px">Sampah Lainnya</p>
							<b-row class="ml-1">
								<b-form-group class="col-md-6" label="Sampah Medis">
									{{ models.sampahMedis }} Kg
								</b-form-group>
								<b-form-group class="col-md-6" label="Battery Aki Bekas">
									{{ models.batteryAkiBekas }} Kg
								</b-form-group>
								<b-form-group class="col-md-6" label="Kain Majun Terkontaminasi B3">
									{{  models.kainMajunTerkontaminasiB3 }} Kg
								</b-form-group>
								<b-form-group class="col-md-6" label="Oli Bekas">
									{{  models.oliBekas }} Kg
								</b-form-group>
							</b-row>
						</div>
					</div>
					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Tujuan Lokasi Penyimpanan (Skala Kota)</label>
						<div class="col-md-9">
							<b-form-group v-if="models.fasilitasTujuan" label="Kota">
								{{ models.fasilitasTujuan.kota ? models.fasilitasTujuan.kota.namaKota : ""  }}
							</b-form-group>
							<b-form-group label="Jenis Fasilitas">
								{{  getJenisFasilitasById(models.jnsFasilitasTujuan) }}
							</b-form-group>
							<b-form-group label="Fasilitas B3 Tujuan">
								<template v-if="models.fasilitasTujuan">
									{{  models.fasilitasTujuan.namaFasilitas }}
								</template>
							</b-form-group>
							<b-form-group label="Alamat Fasilitas B3">
								{{ models.fasilitasTujuan ? models.fasilitasTujuan.alamatFasilitas : "" }}
							</b-form-group>
						</div>
					</div>
				</b-row>
				<template #footer>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import { getJenisFasilitasById } from '@/utils/helpers';
	
	export default {
		name: 'ViewB3Level2Kota',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {

				},
			}
		},
		created() {
			const _ = this
			_.getById();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`PenyimpananKota/${_.$route.params.id}`);
						_.models = request.data.data;
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			getJenisFasilitasById(id) {
				return getJenisFasilitasById(id);
			},
		},
	}
</script>